import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PurchaseOrderNumberComponent} from './purchase-order-number.component';
import {InputModule} from 'ng-design-system';
import {I18nModule} from '@spartacus/core';
import {FormsModule} from '@angular/forms';
import {IconButtonTooltipModule} from '@dcp/configurator';

import '@udex/web-components/dist/TextField';
import '@udex/web-components/dist/Button';
import '@udex/web-components/dist/Tooltip';

@NgModule({
  declarations: [
    PurchaseOrderNumberComponent
  ],
    imports: [
        CommonModule,
        InputModule,
        I18nModule,
        FormsModule,
        IconButtonTooltipModule,
    ],
  exports: [
    PurchaseOrderNumberComponent
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
  ],
})
export class PurchaseOrderNumberModule {
}
